import { View } from "..";
import { ViewModel } from "./mvvm/viewmodel";

export class AttachedPropertyValue{
    public node:Node;
    public value:any;

    constructor(node:Node,value:any) {
        this.node = node;
        this.value = value;
    }
}
export abstract class Component extends ViewModel{
    
}
export abstract class ComponentView<T extends ViewModel> extends View<T>{
    removeAsTemplate(node: HTMLElement): Node {
        (<any>node).isRemoved = true;
        return node;
    }
    append(...nodes: (Node | string)[]): void{
        this.firstlevelElement.append(...nodes);
    }

    attachedToView():void{}
}